import { InputHTMLAttributes, ReactElement } from "react";
import { colors, fontSizing } from "../../theme";
import React from "react";
import { Error } from "./Input";
import styled, { css } from "styled-components";
import { Checkbox, CheckboxLabel } from "../../common/Checkbox";

const Check = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M1.5,13.6L9,22L22.5,1.5"
    />
  </svg>
);

const CheckboxWrap = styled.div`
  font-weight: 300;
  display: flex;
  flex-flow: row wrap;
`;

const CheckboxStyle = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`;

type Props = InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
  label?: string | ReactElement;
  info?: string;
};

export default function FormCheckbox(props: Props) {
  const { error, info, label, ...inputProps } = props;
  return (
    <CheckboxWrap>
      <CheckboxStyle>
        <Checkbox
          type="checkbox"
          {...inputProps}
          id={inputProps.id || inputProps.name}
          onChange={e => {
            inputProps.onChange(e);
          }}
        />
        <CheckboxLabel htmlFor={inputProps.id || inputProps.name}>
          {label}
        </CheckboxLabel>
      </CheckboxStyle>
      {(error || info) && (
        <Error
          id={inputProps.id ? `${inputProps.id}-error` : undefined}
          isError={!!error}
        >
          {info ? info : error}
        </Error>
      )}
    </CheckboxWrap>
  );
}
